/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

/**
 * Enum representing video renderer types for telemedicine.
 * Categorizes video streams as remote participant, local camera, or minimized view.
 * Used with Azure Communication Services for video layout management.
 */
export enum VideoRendererType {
  REMOTE = 'remote',
  LOCAL = 'local',
  MINIMIZED = 'minimized'
}

/**
 * Enum for video scaling modes.
 * Defines how video streams are fitted within display containers.
 * Crop fills the container, Fit maintains aspect ratio with letterboxing.
 */
export enum VideoScalingMode {
  CROP = 'Crop',
  FIT = 'Fit'
}

/**
 * Interface for video stream change events.
 * Tracks added and removed video streams during telemedicine sessions.
 * Used with Azure Communication Services stream management.
 */
export interface VideoStreamEventArgs {
  added?: any[];
  removed?: any[];
}
